<template>
  <v-row justify="center">
    <v-dialog v-model="shower" scrollable persistent max-width="700px">
      <v-card id="borderradius">
          <!-- <v-overlay :value="loaddataprogress" z-index="3" color="black" dark>
        <v-progress-circular indeterminate size="64" color="white">
          <span :style="colorProgress"></span>
        </v-progress-circular>
      </v-overlay> -->
        <!-- <v-card-title v-if="filedata.URL_payment"
          >{{ $t("admintoolbar.paymentlist") }}<v-spacer></v-spacer>
          <v-icon size="35">mdi-credit-card-outline</v-icon>
        </v-card-title>
        <v-card-title v-else
          >{{ $t("packagenew.package_history") }}<v-spacer></v-spacer>
          <v-icon size="35">mdi-clipboard-list-outline</v-icon>
        </v-card-title>
        <v-divider></v-divider> -->
        <v-card-text class="pa-5">
          <v-layout :style="'color:' + color.theme">
            <v-flex d-flex justify-center>
              <h3 v-if="filedata.URL_payment">{{ $t("admintoolbar.paymentlist") }}</h3>
              <h3 v-else>{{ $t("packagenew.package_history") }}</h3>
            </v-flex>
            <v-flex xs1 d-flex justify-end>
              <v-icon :color="color.theme" @click="$emit('closedialog')">close</v-icon>
            </v-flex>
          </v-layout>
          <div v-if="loaddataprogress === true" class="text-center">
            <v-progress-circular indeterminate size="64" :color="color.theme">
              <span :style="colorProgress">&nbsp; &nbsp; loading</span>
            </v-progress-circular>
          </div>
         <div v-for="item in listpayment" :key="item.order">
            <v-layout xs12 lg12 row wrap>
              <v-flex xs5 lg3 class="pl-4 pt-4">
                <p>{{ $t("packagepurchasehistory.package_name") }}<span class="float-right">:</span></p>
              </v-flex>
              <v-flex xs7 lg9 class="pl-4 pt-4">
                <p class="font-weight-bold">
                  {{item.package_name}}
                </p>
              </v-flex>
            </v-layout>
            <v-layout xs12 lg12 row wrap>
              <v-flex xs5 lg3 class="pl-4">
                <p>{{ $t("packagepurchasehistory.detail") }}<span class="float-right">:</span></p>
              </v-flex>
              <v-flex xs7 lg9 class="pl-4">
                <p class="font-weight-bold">{{ $t("default") === 'th' ? item.package_detail : item.package_detail_eng }}</p>
              </v-flex>
            </v-layout>

            <v-layout xs12 lg12 row wrap>
              <v-flex xs5 lg3 class="pl-4">
                <p>{{ $t("packagenew.pricenonvat") }} <span class="float-right">:</span></p>
              </v-flex>
              <v-flex xs7 lg9 class="pl-4">
                <p class="font-weight-bold">{{ $t("default") === 'th' ? item.package_price : item.package_price_eng  }}</p>
              </v-flex>
            </v-layout>

            <v-layout xs12 lg12 row wrap>
              <v-flex xs5 lg3 class="pl-4">
                <p>จำนวน <span class="float-right">:</span></p>
              </v-flex>
              <v-flex xs7 lg9 class="pl-4">
                <p class="font-weight-bold">{{item.packege_quantity }}</p>
              </v-flex>
            </v-layout>
            <v-divider class="my-4"></v-divider>
            </div>

            <div v-if="listpayment.length != 0">
<!-- 
            <v-layout xs12 lg12 row wrap>
              <v-flex xs5 lg3 class="pl-4">
                <p>{{ $t("packagenew.discount") }}<span class="float-right">:</span></p>
              </v-flex>
              <v-flex xs7 lg9 class="pl-4">
                <p class="font-weight-bold">{{ $t("default") === 'th' ? package_detail_all : package_detail_all_eng }}</p>
              </v-flex>
            </v-layout> -->

            <v-layout xs12 lg12 row wrap>
              <v-flex xs5 lg3 class="pl-4">
                <p>{{ $t("packagenew.discount") }}<span class="float-right">:</span></p>
              </v-flex>
              <v-flex xs7 lg9 class="pl-4">
                <p class="font-weight-bold">{{ $t("default") === 'th' ? discount || "0" : discount_eng || "0" }}</p>
              </v-flex>
            </v-layout>

            <v-layout xs12 lg12 row wrap>
              <v-flex xs5 lg3 class="pl-4">
                <p>{{ $t("packagenew.detail_discount_") }}<span class="float-right">:</span></p>
              </v-flex>
              <v-flex xs7 lg9 class="pl-4">
                <p class="font-weight-bold">{{ $t("default") === 'th' ? discription_discount || "-" : discription_discount_eng || "-" }}</p>
              </v-flex>
            </v-layout>

             <v-layout xs12 lg12 row wrap>
              <v-flex xs5 lg3 class="pl-4">
                <p>{{ $t("packagenew.vat_") }}<span class="float-right">:</span></p>
              </v-flex>
              <v-flex xs7 lg9 class="pl-4">
                <p class="font-weight-bold">{{ $t("default") === 'th' ? vat || "0" : vat_eng || "0"   }}</p>
              </v-flex>
            </v-layout>

            <v-layout xs12 lg12 row wrap>
              <v-flex xs5 lg3 class="pl-4">
                <p>{{ $t("packagepurchasehistory.price") }}<span class="float-right">:</span></p>
              </v-flex>
              <v-flex xs7 lg9 class="pl-4">
                <p class="font-weight-bold">
                  {{ $t("default") === 'th' ? numberWithCommas(total_amount) : numberWithCommas(total_amount_eng) }}</p>
              </v-flex>
            </v-layout>
            <!-- <v-layout xs12 lg12 row wrap>
              <v-flex xs5 lg3 class="pl-4">
                <p>
                  {{ $t("packagepurchasehistory.payment_type") }}<span class="float-right">:</span>
                </p>
              </v-flex>
              <v-flex xs7 lg9 class="pl-4" v-if="!filedata.URL_payment">
                <p class="font-weight-bold">{{ item.pay_type || "-" }}</p>
              </v-flex>
            </v-layout> -->
            <!-- <v-layout xs12 lg12 row wrap>
              <v-flex xs5 lg3 class="pl-4">
                <p>{{ $t("paymentlist.payment_date") }}<span class="float-right">:</span></p>
              </v-flex>
              <v-flex xs7 lg9 class="pl-4">
                <p class="font-weight-bold">{{ formatdatetime(item.paid_dtm) }}</p>
              </v-flex>
            </v-layout> -->
            <!-- <v-layout xs12 lg12 row wrap>
              <v-flex xs5 lg3 class="pl-4">
                <p>{{ $t("packagepurchasehistory.date") }}<span class="float-right">:</span></p>
              </v-flex>
              <v-flex xs7 lg9 class="pl-4">
                <p class="font-weight-bold">{{ formatdatetime(item.cre_dtm) }}</p>
              </v-flex>
            </v-layout> -->
            <!-- <v-layout xs12 lg12 row wrap>
              <v-flex xs5 lg3 class="pl-4">
                <p>{{ $t("packagepurchasehistory.payment_status") }}<span class="float-right">:</span></p>
              </v-flex>
              <v-flex xs7 lg9 class="pl-4">
                <p class="font-weight-bold">
                  <v-chip
                    :color="
                      item.status_payment === 'wait' ? $vuetify.theme.dark  ? 'amber--text amber'  : 'amber--text amber lighten-5'
                      : item.status_payment === 'Success' ? $vuetify.theme.dark  ? 'green--text green'  : 'green--text green lighten-5'
                      : $vuetify.theme.dark  ? 'red--text red' : 'red--text red lighten-5'
                    "
                    small
                  >
                    {{ item.status_payment === "Incomplete" ? "Fail" : item.status_payment }}
                  </v-chip>
                </p>
              </v-flex>
            </v-layout> -->
          </div>
          <!-- <v-layout xs12 lg12 row wrap> -->
            <!-- <v-flex xs5 lg3 class="pl-4">
              <p>{{ $t("packagepurchasehistory.tax_invoice") }}<span class="float-right">:</span></p>
            </v-flex> -->
            <!-- <v-flex xs7 lg9 class="pl-4">
              <p>
                <v-btn
                  class="elevation-0 pa-0 font-weight-bold"
                  :disabled="
                    filedata.status_payment !== 'Success' ||
                    filedata.file_id === ''
                  "
                  @click="$emit('downloadtaxinvoice')"
                  color="#1876D1"
                  text 
                  small
                  style="text-decoration: underline;"
                >
                  <span>{{ $t('dowloads')}}</span>
                </v-btn>
              </p>
            </v-flex> -->
          <!-- </v-layout> -->
          <!-- <v-layout xs12 lg12 row wrap v-if="filedata.URL_payment">
            <v-flex xs5 lg3 class="pl-4">
              <p>{{ $t("paymentlist.pay") }}<span class="float-right">:</span></p>
            </v-flex>
            <v-flex xs7 lg9 class="pl-4">
              <p>
                <v-btn
                  class="elevation-0 white--text font-weight-bold"
                  :disabled="
                    filedata.status_payment === 'Success' ||
                    filedata.status_payment === 'Cancel' ||
                    filedata.status_payment === 'success_nexmount'
                  "
                  @click="$emit('payment')"
                  :color="color.theme"
                  small
                >
                  {{ $t("paymentlist.btnpay") }}
                </v-btn>
              </p>
            </v-flex>
          </v-layout> -->
        </v-card-text>
        <!-- <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="$emit('closedialog')" color="red" dark>{{
            $t("resendfile.closefromdateresend")
          }}</v-btn>
        </v-card-actions> -->
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "vue-full-screen-file-drop/dist/vue-full-screen-file-drop.css";
import "swiper/css/swiper.css";
import gbfGenerate from "@/globalFunctions/generateAuthorize";
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  props: ["show", "filedata"],
  data: function() {
    return {
      loaddataprogress:false,
      listpayment:[],
      amount: "",
      amount_eng: "",
      discount: "",
      discount_eng: "",
      discription_discount: "",  
      package_detail_all: "",
      package_detail_all_eng: "",
      package_name_addon: "",
      package_name_main: "",
      total: "",
      total_amount: "",
      total_amount_eng: "",
      total_eng: "",
      vat: "",
      vat_eng : "",
    };
  },
  computed: {
    ...mapState([
      "username",
      "authorize",
      "account_active",
      "color",
      "storage_usage",
    ]),
    ...mapState({ processloader: "loading" }),
    ...mapGetters([
      "dataUsername",
      "dataAuthorize",
      "dataAccountActive",
      "dataAccesstoken",
      "dataBusinessProfile",
      "dataCitizenProfile",
      "dataDepartmentAccessId",
      "dataAccountId",
      "dataStorageUsage",
      "dataStorageMax",
    ]),
    shower: {
      get() {
        if (this.show === true) {
          this.fn_getdetail_package();
          // this.fn_get_history();
          // console.log('fileresend',this.fileresend);
        }
        return this.show;
      },
    },
  },
  methods: {
    numberWithCommas(x) {
      if (!x || x === null || x === undefined) {
        return "-";
      } else {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    formatdatetime(_datetime) {
      if (
        _datetime === "" ||
        _datetime === "-" ||
        _datetime === undefined ||
        _datetime === null
      ) {
        return "-";
      } else {
        let dateyear =
          _datetime.split("")[0] +
          _datetime.split("")[1] +
          _datetime.split("")[2] +
          _datetime.split("")[3];
        let datemonth = _datetime.split("")[4] + _datetime.split("")[5];
        let dateday = _datetime.split("")[6] + _datetime.split("")[7];
        let hour = _datetime.split("")[8] + _datetime.split("")[9];
        let minute = _datetime.split("")[10] + _datetime.split("")[11];
        let second = _datetime.split("")[12] + _datetime.split("")[13];

        return (
          dateday +
          "/" +
          datemonth +
          "/" +
          dateyear +
          " " +
          hour +
          ":" +
          minute +
          ":" +
          second
        );
      }
    },
    async fn_get_history() {

      this.listpayment = [];
      let payload = {
        data_id: this.dataAccountActive.type === 'Citizen' ? this.dataAccountId : this.dataAccountActive.business_info.business_id,
        type: this.dataAccountActive.type === 'Citizen' ? 'citizen': 'business',
        name_buyer_th: "",
        name_buyer_eng: "",
        order_id: this.filedata.order_id,
        status_payment: "",
        paid_dtm_start: "",
        paid_dtm_end: "",
      };
      console.log("payload fn_get_history", payload);
       let auth = await gbfGenerate.generateToken();
      this.axios
        .post(
          process.env.VUE_APP_SERVICE_ADMIN + "/api/get_list_payment",
          payload,
           {headers: { Authorization: auth.code } }
        )
        .then((response) => {
          // console.log("res*", response.data.list_payment);
          if (response.data.status === "OK") {
            console.log("response", response);
            for (var i = 0; i < response.data.result.length; i++) {
              let datapatment = {};
              datapatment["cre_dtm"] = response.data.result[i].cre_dtm;
              datapatment["discount"] = response.data.result[i].discount;
              datapatment["discription_discount"] = response.data.result[i].discription_discount;
              datapatment["file_id"] = response.data.result[i].file_id;
              datapatment["grand_total"] = response.data.result[i].grand_total;
              datapatment["order_id"] = response.data.result[i].order_id;
              datapatment["package_detail_all"] = response.data.result[i].package_detail_all;
              datapatment["paid_dtm"] = response.data.result[i].paid_dtm;
              datapatment["status_payment"] = response.data.result[i].status_payment;
              datapatment["sub_total"] = response.data.result[i].sub_total;
              datapatment["vat_amount"] = response.data.result[i].vat_amount;
              // datapatment["bank_no"] = response.data.result[i].bank_no;
              // datapatment["data_id"] = response.data.result[i].data_id;
              // datapatment["name_buyer_eng"] = response.data.result[i].name_buyer_eng;
              // datapatment["name_buyer_th"] = response.data.result[i].name_buyer_th;
              // datapatment["number_user"] = response.data.result[i].number_user;
              // datapatment["order_payment_id"] = response.data.result[i].order_payment_id;
              // datapatment["package_id"] = response.data.result[i].package_id;
              // datapatment["package_name"] = response.data.result[i].package_name;
              // datapatment["package_name_th"] = response.data.result[i].package_name_th;
              // datapatment["package_name_addon"] = response.data.result[i].package_name_addon;
              // datapatment["package_storage"] = response.data.result[i].package_storage;
              // datapatment["pay_type"] = response.data.result[i].pay_type;
              // datapatment["period"] = response.data.result[i].period;
              // datapatment["type_package"] = response.data.result[i].type_package;
              // datapatment["types"] = response.data.result[i].types;
              // datapatment["ref1"] = response.data.result[i].ref1;
              // datapatment["quantity_addon"] = response.data.result[i].quantity_addon;
              // datapatment["quantity_main"] = response.data.result[i].quantity_main;
              // datapatment["package_storage_main"] = response.data.result[i].package_storage_main;
              this.listpayment.push(datapatment);
              // this.rootfile.push(datapatment);
            }

            console.log("this.rootfile", this.rootfile);
            // console.log("++++++", this.id_mypackage);
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.errorMessage,
            });
          }
        });
    },
    async fn_getdetail_package(){
      this.loaddataprogress = true;
       this.listpayment = [];
        let payload = {
        order_id: this.filedata.order_id,
      };
         let auth = await gbfGenerate.generateToken();
        this.axios
          .post(process.env.VUE_APP_SERVICE_ADMIN_BOX + "/api/get_detail_list_payment", payload, {
            headers: { Authorization: auth.code },
          })
          .then((response) => {
            if (response.data.status === "OK") {
              console.log("response.data.list_detail[1]",response.data.list_detail[1]);
              
            for (var i = 0; i < response.data.list_detail.length; i++) {
              let datapatment = {};
              datapatment["order"] = response.data.list_detail[i].order;
              datapatment["package_detail"] = response.data.list_detail[i].package_detail;
              datapatment["package_detail_eng"] = response.data.list_detail[i].package_detail_eng;
              datapatment["package_id"] = response.data.list_detail[i].package_id;
              datapatment["package_name"] = response.data.list_detail[i].package_name;
              datapatment["package_price"] = response.data.list_detail[i].package_price;
              datapatment["package_price_eng"] = response.data.list_detail[i].package_price_eng;
              datapatment["package_total_price"] = response.data.list_detail[i].package_total_price;
              datapatment["package_total_price_eng"] = response.data.list_detail[i].package_total_price_eng;
              datapatment["packege_amount"] = response.data.list_detail[i].packege_amount;
              datapatment["packege_amount_eng"] = response.data.list_detail[i].packege_amount_eng;
              datapatment["packege_quantity"] = response.data.list_detail[i].packege_quantity;
              this.listpayment.push(datapatment);
            }

             this.amount = response.data.result.amount;
             this.amount_eng = response.data.result.amount_eng;
             this.discount = response.data.result.discount;
             this.discount_eng = response.data.result.discount_eng;
             this.discription_discount = response.data.result.discription_discount;
             this.package_detail_all = response.data.result.package_detail_all;
             this.package_detail_all_eng = response.data.result.package_detail_all_eng;
             this.package_name_addon = response.data.result.package_name_addon;
             this.package_name_main = response.data.result.package_name_main;
             this.total = response.data.result.total;
             this.total_amount = response.data.result.total_amount;
             this.total_amount_eng = response.data.result.total_amount_eng;
             this.total_eng = response.data.result.total_eng;
             this.vat = response.data.result.vat;
             this.vat_eng = response.data.result.vat_eng;

             this.loaddataprogress = false;
 
            } else {
              this.loaddataprogress = false;
              Toast.fire({
                icon: "error",
                title: response.data.errorMessage,
              });
            }
          });

    },
  },
};
</script>
